import React from 'react';
import { Box, TextField, MenuItem, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ShoppingListGroceryFormData } from '../types/ShoppingListGrocery';
import { Grocery } from '../types/Grocery';

interface ShoppingListGroceryFormProps {
  formData: ShoppingListGroceryFormData;
  onChange: (field: keyof ShoppingListGroceryFormData, value: string) => void;
  errors?: Partial<Record<keyof ShoppingListGroceryFormData, string>>;
  availableGroceries: Grocery[];
  isEditing?: boolean;
}

const ShoppingListGroceryForm: React.FC<ShoppingListGroceryFormProps> = ({
  formData,
  onChange,
  errors = {},
  availableGroceries,
  isEditing = false,
}) => {
  // Format grocery label for dropdown
  const formatGroceryLabel = (grocery: Grocery): string => {
    const parts = [grocery.name];
    if (grocery.brand) parts.push(`(${grocery.brand})`);
    if (grocery.packaging_size) parts.push(`- ${grocery.packaging_size}`);
    return parts.join(' ');
  };

  return (
    <Box component="form" noValidate autoComplete="off">
      <Grid container spacing={2}>
        {/* Grocery Dropdown */}
        <Grid size={12}>
          <TextField
            select
            label="Grocery"
            value={formData.grocery}
            onChange={(e) => onChange('grocery', e.target.value)}
            fullWidth
            required
            error={!!errors.grocery}
            helperText={errors.grocery}
            disabled={isEditing}
          >
            {availableGroceries.length === 0 ? (
              <MenuItem disabled>
                <Typography variant="body2" color="text.secondary">
                  No groceries available to add
                </Typography>
              </MenuItem>
            ) : (
              availableGroceries.map((grocery) => (
                <MenuItem key={grocery.id} value={grocery.id.toString()}>
                  {formatGroceryLabel(grocery)}
                </MenuItem>
              ))
            )}
          </TextField>
        </Grid>

        {/* Quantity */}
        <Grid size={12}>
          <TextField
            label="Quantity"
            type="number"
            value={formData.quantity}
            onChange={(e) => onChange('quantity', e.target.value)}
            fullWidth
            required
            error={!!errors.quantity}
            helperText={errors.quantity}
            inputProps={{ min: 1, step: 1 }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ShoppingListGroceryForm;